import React, { useState } from 'react';
import './EmpresaSwitcher.css';

const EmpresaSwitcher = ({ user, empresaAtual, onEmpresaChange }) => {
  const [showDropdown, setShowDropdown] = useState(false);

  if (!user || !user.empresasVinculadas || user.empresasVinculadas.length <= 1) {
    return null;
  }

  const handleEmpresaChange = (empresaId) => {
    onEmpresaChange(empresaId);
    setShowDropdown(false);
  };

  return (
    <div className="empresa-switcher">
      <button 
        className="empresa-switcher-button"
        onClick={() => setShowDropdown(!showDropdown)}
      >
        <span>{empresaAtual?.fantasia || 'Selecionar Empresa'}</span>
        <span className="dropdown-arrow">▼</span>
      </button>

      {showDropdown && (
        <div className="empresa-dropdown">
          {user.empresasVinculadas.map(empresa => (
            <div
              key={empresa.id}
              className={`empresa-option ${empresa.id === empresaAtual?.id ? 'active' : ''}`}
              onClick={() => handleEmpresaChange(empresa.id)}
            >
              <div className="empresa-name">{empresa.fantasia}</div>
              <div className="empresa-role">{empresa.role}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmpresaSwitcher;
